<script>
    import CheckBox from '../../lib/components/CheckBox.svelte';
    import InputWithValidation from '../../lib/components/InputField.svelte';
    import Selector from '../../lib/components/Selector.svelte';
    import { onMount } from 'svelte';
    import { MDCDialog } from '@material/dialog';
    import { TS } from '../../config/translation-keys.js';
    import { t9n } from '../../lib/translate.js';

    export let labels;
    export let close_dialog_edu;
    export let dialog_edit_edu;
    export let form_input;
    export let selectors;
    export let add_new_education;

    let dialog;
    let education_selecting = false;

    const init_dialog = () => {
        dialog = new MDCDialog(document.getElementById(`edu-dialog`));


    };

    export const open = () => {
        dialog.open();
    };

    export const close = () => {
        dialog.close();
    };

    const reset_date_values = (checked) => {
        if(checked){
            form_input.education.completed.month = null;
            form_input.education.completed.year = null;
            form_input.education.completed.month_edit = null;
            form_input.education.completed.year_edit = null;

        }
    }

    const auto_complete_year = (year) => {
        if(!!year){
            if(year.toString().length === 4){
                let items = selectors.education.years;
                items.forEach(e => {
                    if(e.name === year.toString()){
                        form_input.education.completed.year = e.val;
                        education_selecting = false;
                    }
                })
            } else {
                form_input.education.completed.year = 1;
            }

        }

    }

    const auto_complete_edit_year = (year) => {
        if(!!year){
            if(year.toString().length === 4){
                let items = selectors.education.years;
                items.forEach(e => {
                    if(e.name === year.toString()){
                        form_input.education.completed.year_edit = e.val;
                        education_selecting = false;
                    }
                })
            } else {
                form_input.education.completed.year_edit = 1;
            }

        }
    }

    $: auto_complete_year(form_input.education.input_value_year);
    $: auto_complete_edit_year(form_input.education.input_value_year);

    $: reset_date_values(form_input.education.completed.current);


    // $: if(education_selecting){
    //     const targetElement = document.getElementById("selector_completed_year-options");
    //
    //     console.log('nana', targetElement)
    //     // let element = document.getElementById('education-content');
    //     // element.scrollTop = element.scrollHeight;
    //     // element.scrollIntoView({ behavior: 'smooth' });
    //
    // }

    onMount(init_dialog);
</script>

<style>
    .required{
        font-size: 10pt;
        margin-bottom: 20px;
        color: #323232;
        margin-left: 50px;
    }

    .mdc-dialog__content {
        overflow: visible;
        overflow-y: auto;
    }

    .mdc-dialog__surface {
        width: 450px;
    }

    .mdc-layout-grid {
        padding: 0;
    }


    /* Desktop Mode
    *******************************************************/
    @media (min-width: 1025px) {
        .margin-50 {
            margin-left: 50px;
        }

        .padding-50 {
            padding-left: 50px;
        }
    }

    /* Tablet Mode
    *******************************************************/
    @media (min-width: 769px) and (max-width: 1024px) {
        .mdc-dialog__surface {
            height: 100%;
            max-height: 650px;
        }

        .margin-50 {
            margin-left: 50px;
        }

        .padding-50 {
            padding-left: 50px;
        }

    }

    /* Mobile Mode
    *******************************************************/
    @media (min-width: 0) and (max-width: 768px) {
        .margin-50 {
            margin-left: 1px;
        }

        .padding-50 {
            padding-left: 1px;
        }

        .mdc-dialog__surface {
            height: 80%;
            max-height: 625px;
        }
    }

</style>

<div id="edu-dialog"
     class="mdc-dialog">
    <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface"
             role="alertdialog"
             aria-modal="true"
             aria-labelledby="my-dialog-title"
             aria-describedby="my-dialog-content"
             style="overflow: visible">

            <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
            <h2 class="mdc-dialog__title"
                id="education-title">

                {#if !dialog_edit_edu}
                    {labels.add_education}
                {:else}
                    {labels.edit_edu}
                {/if}

            </h2>

            <div class="mdc-dialog__content"
                 id="education-content"
                 style="overflow: visible; overflow-y: auto">

                <div style="display: flex; margin-top: 40px; margin-bottom: 10px; height: 62px"
                     class="margin-50">

                    {#if !dialog_edit_edu}

                        <div style="width: 300px">
                            <Selector
                              id="selector_type"
                              label={labels.type}
                              is_required={true}
                              bind:input_value={form_input.education.input_value_education}
                              bind:items={selectors.education.type}
                              bind:value={form_input.education.type}/>
                        </div>
                    {:else}
                        <div style="width: 300px">
                            <Selector
                              id="selector_type_edit"
                              label={labels.type}
                              is_required={true}
                              bind:input_value={form_input.education.input_value_education}
                              bind:items={selectors.education.type}
                              bind:value={form_input.education.type_edit}/>
                        </div>
                    {/if}

                </div>


                <div style="display: flex;"
                     class="margin-50">
                    <InputWithValidation
                      id="input-title"
                      type="text"
                      label={labels.title}
                      name="code"
                      is_required={true}
                      bind:value={form_input.education.title}
                      validate={false}
                      is_tooltip_default={false}
                      width="300px">
                    </InputWithValidation>
                </div>

                <div style="display: flex;"
                     class="margin-50">
                    <InputWithValidation
                      id="input-where"
                      type="text"
                      label={labels.where}
                      name="code"
                      is_required={true}
                      bind:value={form_input.education.where}
                      validate={false}
                      is_tooltip_default={false}
                      width="300px">
                    </InputWithValidation>
                </div>
                {#if !form_input.education.completed.current}
                    {#if !dialog_edit_edu}
                        <div style="display: flex; margin-bottom: 10px; height: 63px"
                             class="margin-50">

                            <div style="width: 300px">
                                <Selector
                                  id="selector_completed_month"
                                  label={labels.completed_month}
                                  is_required={true}
                                  bind:input_value={form_input.education.input_value_month}
                                  bind:items={selectors.education.months}
                                  bind:value={form_input.education.completed.month}/>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 10px; height: 63px"
                             class="margin-50">


                            <div style="width: 300px">
                                <Selector
                                  id="selector_completed_year"
                                  label={labels.completed_year}
                                  is_required={true}
                                  max_length={4}
                                  bind:selecting={education_selecting}
                                  bind:input_value={form_input.education.input_value_year}
                                  bind:items={selectors.education.years}
                                  bind:value={form_input.education.completed.year}/>
                            </div>
                        </div>
                    {:else}
                        <div style="display: flex; margin-left: 50px; margin-bottom: 10px; height: 63px">

                            <div style="width: 300px">
                                <Selector
                                  id="selector_completed_month"
                                  label={labels.completed_month}
                                  is_required={true}
                                  bind:input_value={form_input.education.input_value_month}
                                  bind:items={selectors.education.months}
                                  bind:value={form_input.education.completed.month_edit}/>
                            </div>
                        </div>
                        <div style="display: flex; margin-left: 50px; margin-bottom: 10px; height: 63px">
                            <div style="width: 300px">
                                <Selector
                                  id="selector_completed_year"
                                  label={labels.completed_year}
                                  is_required={true}
                                  max_length={4}
                                  bind:selecting={education_selecting}
                                  bind:input_value={form_input.education.input_value_year}
                                  bind:items={selectors.education.years}
                                  bind:value={form_input.education.completed.year_edit}/>
                            </div>
                        </div>
                    {/if}
                {:else}
                    <div style="display: flex; margin-bottom: 10px;"
                         class="margin-50">
                        <InputWithValidation
                                id="selector_completed_month"
                                type="text"
                                label={labels.completed_month}
                                bind:value={form_input.education.completed.month}
                                validate={false}
                                is_required={true}
                                disabled={form_input.education.completed.current}
                                margin_bottom="7px"
                                width="300px">
                        </InputWithValidation>
                    </div>
                    <div style="display: flex; margin-bottom: 10px;"
                         class="margin-50">
                        <InputWithValidation
                                id="selector_start_year"
                                type="text"
                                label={labels.completed_year}
                                bind:value={form_input.education.completed.year}
                                validate={false}
                                is_required={true}
                                disabled={form_input.education.completed.current}
                                margin_bottom="7px"
                                width="300px">
                        </InputWithValidation>
                    </div>
                {/if}

                <div class="margin-50">
                    <CheckBox id="date-cbox"
                              bind:value={form_input.education.completed.current}
                              label={labels.current}
                    />
                </div>

                <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>
            </div>

            <footer class="mdc-dialog__actions">
                <button on:click={() => close_dialog_edu()}
                        data-mdc-dialog-initial-focus
                        class="btn-close mdc-button mdc-button--unelevated">
                    <span class="mdc-button__ripple"></span>
                    {labels.btn_close}
                </button>

                {#if !dialog_edit_edu}
                    {#if !!form_input.education.type && !!form_input.education.title && !!form_input.education.where}
                        {#if !form_input.education.completed.current}
                            {#if !!form_input.education.completed.month && !!form_input.education.completed.year && form_input.education.completed.year > 1}
                                <button on:click={() => add_new_education()}
                                        style="margin-left: 10px;"
                                        data-mdc-dialog-initial-focus
                                        class="btn-close mdc-button mdc-button--unelevated">
                                    <span class="mdc-button__ripple"></span>
                                    {labels.btn_add}
                                </button>
                            {:else}
                                <button on:click={() => add_new_education()}
                                        disabled
                                        data-mdc-dialog-initial-focus
                                        style="margin-left: 10px;"
                                        class="btn-close mdc-button mdc-button--unelevated">
                                    <span class="mdc-button__ripple"></span>
                                    {labels.btn_add}
                                </button>
                            {/if}
                        {:else}
                            <button on:click={() => add_new_education()}
                                    style="margin-left: 10px;"
                                    data-mdc-dialog-initial-focus
                                    class="btn-close mdc-button mdc-button--unelevated">
                                <span class="mdc-button__ripple"></span>
                                {labels.btn_add}
                            </button>
                        {/if}


                    {:else}
                        <button on:click={() => add_new_education()}
                                disabled
                                style="margin-left: 10px;"
                                data-mdc-dialog-initial-focus
                                class="btn-close mdc-button mdc-button--unelevated">
                            <span class="mdc-button__ripple"></span>
                            {labels.btn_add}
                        </button>
                    {/if}
                {:else}
                    {#if !!form_input.education.type_edit && !!form_input.education.title
                    && !!form_input.education.where}
                        {#if !form_input.education.completed.current}
                            {#if !!form_input.education.completed.month_edit
                            && !!form_input.education.completed.year_edit && form_input.education.completed.year_edit > 1}
                                <button on:click={() => add_new_education()}
                                        style="margin-left: 10px;"
                                        data-mdc-dialog-initial-focus
                                        class="btn-close mdc-button mdc-button--unelevated">
                                    <span class="mdc-button__ripple"></span>
                                    {labels.btn_save}
                                </button>
                            {:else}
                                <button on:click={() => add_new_education()}
                                        disabled
                                        style="margin-left: 10px;"
                                        data-mdc-dialog-initial-focus
                                        class="btn-close mdc-button mdc-button--unelevated">
                                    <span class="mdc-button__ripple"></span>
                                    {labels.btn_save}
                                </button>
                            {/if}
                        {:else}
                            <button on:click={() => add_new_education()}
                                    style="margin-left: 10px;"
                                    data-mdc-dialog-initial-focus
                                    class="btn-close mdc-button mdc-button--unelevated">
                                <span class="mdc-button__ripple"></span>
                                {labels.btn_save}
                            </button>
                        {/if}


                    {:else}
                        <button on:click={() => add_new_education()}
                                disabled
                                style="margin-left: 10px;"
                                data-mdc-dialog-initial-focus
                                class="btn-close mdc-button mdc-button--unelevated">
                            <span class="mdc-button__ripple"></span>
                            {labels.btn_save}
                        </button>
                    {/if}
                {/if}

            </footer>
        </div>
    </div>

    <div class="mdc-dialog__scrim"></div>
</div>